import { render, staticRenderFns } from "./ClientList_List_Action.vue?vue&type=template&id=063f3538&"
import script from "./ClientList_List_Action.vue?vue&type=script&lang=js&"
export * from "./ClientList_List_Action.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports